export enum CALENDAR_FILTER_STATUS {
  CREATED = 'CREATED',
  CANCELED_BY_CUSTOMER = 'CANCELED_BY_CUSTOMER',
}
